// extracted by mini-css-extract-plugin
module.exports = {"container":"_2tt14uBC5AkFiYVQ2Uxl6s"};